export const BRAND = {
  navy: '#0d0814',
  navyLight: '#1a1224',
  slate: '#241834',
  warm: '#7c3aa5',
  warmLight: '#a874c9',
  warmDark: '#5e2885',
  warmGlow: 'rgba(124,58,165,0.15)',
  teal: '#33b8b8',
  tealLight: '#7ed9d9',
  tealDark: '#1e8585',
  tealGlow: 'rgba(51,184,184,0.15)',
  cream: '#faf7f3',
  white: '#ffffff',
  text: '#0d0814',
  textMid: '#3d2a4c',
  textLight: '#6b5b7a',
  success: '#2d6a4f',
  successBg: '#ecfdf5',
  danger: '#c0392b',
  dangerBg: '#fef2f2',
  border: '#e6dfec',
  borderLight: '#f3eff5',
} as const;

export const FONTS = {
  heading: "'Cormorant Garamond', Georgia, serif",
  body: "'DM Sans', sans-serif",
} as const;
